import { useCallback, useState } from 'react';
import { Stack } from '@chaser/components';
import FileUpload from '../../../../components/FileUpload';
import ImportService from '../../../../services/import-service';
import { toast } from '../../../../components/ToastContainer';
import SkippedInvoicesWarning from './SkippedInvoicesWarning';

const DataUpload = ({ shortCode, type, maxFileSize }) => {
  const [skippedResult, setSkippedResult] = useState(null);

  const onAllFilesUploaded = useCallback(
    async (successes, failures) => {
      setSkippedResult(null);

      if (failures.length > 0) {
        const err = new Error('Upload failed, please try again.');
        err.expose = true;
        throw err;
      } else {
        const { prefix, name } = successes[0];
        try {
          const result = await ImportService.importCSV(shortCode, prefix, name, type.id);
          toast.success('Upload successful');

          if (result?.skippedCount > 0) {
            setSkippedResult({ skippedCount: result.skippedCount, skipped: result.skipped });
          }
        } catch (error) {
          if (error.code === 'CSV_VALIDATION_ERROR') {
            const err = new Error('We could not process your file due to the following errors:', {
              cause: error,
            });
            err.rejectedFiles = [
              {
                name,
                errors: error.meta.errors.map(e => ({ message: e })),
                hideName: true,
              },
            ];
            err.summary =
              'Please review your upload and your configuration settings before uploading again.';
            err.expose = true;
            throw err;
          } else {
            throw error;
          }
        }
      }
    },
    [shortCode, type],
  );

  return (
    <Stack gap="medium">
      <FileUpload
        accept={{ 'text/csv': ['.csv'] }}
        maxSize={maxFileSize}
        getUploadInfo={ImportService.getCSVUploadLinks.bind(null, shortCode)}
        onAllFilesUploaded={onAllFilesUploaded}
      />
      {skippedResult && (
        <SkippedInvoicesWarning
          skippedCount={skippedResult.skippedCount}
          skipped={skippedResult.skipped}
        />
      )}
    </Stack>
  );
};

export default DataUpload;
